import { motion } from 'framer-motion';

const outputs = [
  {
    num: '01',
    name: 'AI-Powered Workflows',
    desc: 'Automation, agent concepts, and intelligent systems tailored to your business.',
  },
  {
    num: '02',
    name: 'Creative Concept Directions',
    desc: 'Visual identity, brand language, and creative strategy for new ventures.',
  },
  {
    num: '03',
    name: 'Custom AI Solutions',
    desc: 'Agent design, prototype development, and technology integration paths.',
  },
  {
    num: '04',
    name: 'Business Strategy',
    desc: 'Enhancement opportunities, market positioning, and growth architecture.',
  },
  {
    num: '05',
    name: 'Prototypes & MVPs',
    desc: 'Working models that turn abstract ideas into testable, tangible products.',
  },
  {
    num: '06',
    name: 'Generative Media',
    desc: 'Visual explorations, concept art, and AI-assisted creative production.',
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
};

export default function Services() {
  return (
    <section id="work" className="py-24 md:py-36" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="section-divider mb-12" />

        <motion.p className="section-number" {...fadeUp} data-testid="services-number">
          03 / Outputs
        </motion.p>
        <motion.h2
          className="section-title mt-3 mb-4"
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="services-title"
        >
          What We
          <br />
          Help Create
        </motion.h2>
        <motion.p
          className="text-[var(--cv-text-dim)] text-sm md:text-base max-w-[520px] mb-12 md:mb-16"
          style={{ fontFamily: 'var(--font-body)' }}
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          data-testid="services-subtitle"
        >
          Every engagement produces something tangible &mdash;
          a prototype, a strategy, a system, or a clear direction
          you can act on.
        </motion.p>

        <div data-testid="services-list">
          {outputs.map((s, i) => (
            <motion.div
              key={s.num}
              className="service-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{
                duration: 0.6,
                delay: 0.08 * i,
                ease: [0.16, 1, 0.3, 1],
              }}
              data-testid={`service-item-${s.num}`}
            >
              <span className="service-num">({s.num})</span>
              <span className="service-name">{s.name}</span>
              <span className="service-desc">{s.desc}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
